export default __webpack_public_path__ + "static/media/atmosphere-current-final.0afdcb1f.svg";